import {BLACK_ROUTE_PATH} from "../constant.js"
export const tabNavigation = {
  namespaced: true,
  state: () => {
    return {
      navigationList: [],
      showTabNavigation:true,
    };
  },
  mutations: {
    addNavigation: function({ navigationList }, payload) {
      if (BLACK_ROUTE_PATH.some((path) => path === payload.path)) return;
      navigationList.map((nav) => {
        nav.selected = false;
        return nav;
      });
      navigationList
        .filter(({ path }) => path == payload.path)
        .map((nav) => {
          nav.selected = true;
          return nav;
        });
      if (!navigationList.some(({ path }) => path == payload.path)) {
        navigationList.push({
          ...JSON.parse(JSON.stringify(payload)),
          selected: true,
        });
      }
    },

    delNavigation: function(state, payload) {
      // if (payload.selected) return;
      const del = state.navigationList.splice(
        state.navigationList.findIndex((nav) => nav.path === payload.path),
        1
      );
    },
    selectedNavigation: function({ navigationList }, payload) {
      navigationList.map((nav) => {
        nav.selected = false;
        if (nav.path === payload.path) {
          nav.selected = true;
        }
        return nav;
      });
    },
    setShowTabNavigation:function(state,payload){
    
      state.showTabNavigation=payload;
    },
    delFirstNavigation:function(state){
      state.navigationList.shift();
    }
  },
  actions: {},
  getters: {
    currentNavigationList(state) {
      return state.navigationList.slice(0, 10);
    },
    
  },
};
